import { Card, Collapse, IconButton, ListItem, ListItemText } from "@mui/material";
import { Edit as EditIcon, ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Overlayer } from "src/types";
import { legendGraphicUrl } from "src/utils/ogc.utils";
import { isWMSOverlayer, layerName } from "src/utils/overlayer.utils";
import { isComponentLegend, isWMSLegend } from "src/utils/legend.utils";
import { pick } from "lodash";

interface Props {
  layer: Overlayer;
  onEdit?: () => void;
}

export function OverlayersLegendItem(props: Props) {
  const { layer } = props;
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();

  return render();

  function render() {
    return (
      <Styles>
        <ListItem button onClick={() => setIsOpen(!isOpen)} className="header">
          <ListItemText
            primary={layerName(layer, t)}
            secondary={
              <span className="sub-section">
                <small>
                  {layer.unit
                    ? t(`label.${layer.unit}`) !== `label.${layer.unit}`
                      ? t(`label.${layer.unit}`)
                      : layer.unit
                    : ""}
                </small>
                {layer.ifdmType && <small>-</small>}
                {layer.ifdmType && <small>{`${layer.ifdmType}`}</small>}
              </span>
            }
            color="primary"
          />
          {layer.layerManager?.showBackLegend && (
            <IconButton
              onMouseDown={(event) => event.stopPropagation()}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                if (props.onEdit) props.onEdit();
              }}
            >
              <EditIcon color="action" fontSize="small" />
            </IconButton>
          )}
          {isOpen ? <ExpandLessIcon color="action" /> : <ExpandMoreIcon />}
        </ListItem>
        <Collapse in={isOpen}>
          <div className="legend-content">
            {isWMSOverlayer(layer) && isWMSLegend(layer.legend) && (
              <img src={legendGraphicUrl(layer)} alt={`overlayer legend ${layer.translationKey}`} />
            )}
            {isComponentLegend(layer.legend) && renderComponentLegend()}
          </div>
        </Collapse>
      </Styles>
    );
  }

  function renderComponentLegend() {
    if (!isComponentLegend(layer.legend)) return null;

    const componentProps = pick(props, ["onEdit"]);
    return <layer.legend.component {...componentProps} />;
  }
}

const Styles = styled(Card)`
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top: 1px solid #e7e7e7;
    padding: ${({ theme }) => theme.spacing(1, 2)};
    margin: 0;
    color: ${({ theme }) => theme.palette.text.primary};
  }

  .legend-content {
    padding: ${({ theme }) => theme.spacing(1, 2, 2)};
  }

  .sub-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
  }
`;
